<template>
  <div class="camp">
    <div class="top-content">
      <div class="wdd">
        <p class="top-tip">2020夏季和2021冬季营地项目报名通道已开启！！</p>
        <swiper ref="mySwiper" :options="swiperOptions" class="swiper-wrappe carousel">
          <swiper-slide class="swiper-slide demo-carousel">
            <img src="@/assets/camp/w1.png" alt />
          </swiper-slide>
          <swiper-slide class="swiper-slide demo-carousel">
            <img src="@/assets/camp/w3.png" alt />
          </swiper-slide>
          <swiper-slide class="swiper-slide demo-carousel">
            <img src="@/assets/camp/w2.png" alt />
          </swiper-slide>
        </swiper>
        <!-- <Carousel autoplay
                  class="carousel"
                  loop
                  easing="fade"
                  :autoplay-speed="5000">
          <Carousel-item class="demo-carousel">
            <img src="@/assets/camp/w1.png"
                 alt="" />
          </Carousel-item>
          <Carousel-item class="demo-carousel">
            <img src="@/assets/camp/w3.png"
                 alt="" />
          </Carousel-item>
          <Carousel-item class="demo-carousel">
            <img src="@/assets/camp/w2.jpg"
                 alt="" />
          </Carousel-item>
        </Carousel>-->
        <div class="camp-word">
          <h1>STEAM国内夏冬令营</h1>
          <p>专注于青少年STEAM教育和传统营地教育</p>
          <p>融合中华传统文化和人文自然</p>
          <router-link to="/inside-camp">国内营地</router-link>
          <router-link to="/outside-camp">国外营地</router-link>
        </div>
      </div>
    </div>
    <div class="explain">
      <svg-icon class="wave" icon-class="wavecamp"></svg-icon>
    </div>
    <div class="content">
      <div class="wd">
        <img src="@/assets/camp/c1.jpg" alt />
        <p class="item-title">满足孩子成长阶段的不同的学习需求</p>
        <p class="small-title">适合6~18岁青少年的STEAM创客主题课程</p>
        <Row class="require" type="flex" justify="center">
          <i-col span="7">
            <Card :shadow="true" class="card-list">
              <img src="@/assets/camp/t1.jpg" alt />
              <p class="card-title">模块化编程</p>
              <span>青少年编程入门，营员将创作热门的游戏和动画</span>
            </Card>
          </i-col>
          <i-col span="7">
            <Card :shadow="true" class="card-list">
              <img src="@/assets/camp/t2.png" alt />
              <p class="card-title">Python编程</p>
              <span>零基础入门，利用Python代码提升逻辑思维能力</span>
            </Card>
          </i-col>
          <i-col span="7">
            <Card :shadow="true" class="card-list">
              <img src="@/assets/camp/t3.jpg" alt />
              <p class="card-title">AI人工智能课程</p>
              <span>熟知前沿AI人工智能产品的原理，并利用基础硬件进行创作</span>
            </Card>
          </i-col>
          <i-col span="7">
            <Card :shadow="true" class="card-list">
              <img src="@/assets/camp/t4.jpg" alt />
              <p class="card-title">3D打印创作</p>
              <span>熟悉掌握3D建模软件和3D打印机的日常应用与维修</span>
            </Card>
          </i-col>
          <i-col span="7">
            <Card :shadow="true" class="card-list">
              <img src="@/assets/camp/t5.png" alt />
              <p class="card-title">机器人硬件拼装</p>
              <span>学习结构设计、硬件拼装，并通过编程实现相应功能</span>
            </Card>
          </i-col>
          <i-col span="7">
            <Card :shadow="true" class="card-list">
              <img src="@/assets/camp/t6.png" alt />
              <p class="card-title">世界机器人大赛突击营</p>
              <span>学习结构设计、硬件拼装，并通过编程实现相应功能</span>
            </Card>
          </i-col>
        </Row>
        <img src="@/assets/camp/c1.jpg" alt />
        <p class="item-title">项目式营地学习，让孩子领先于同龄人</p>
        <p class="small-title">将名校内容融合最新的教育理念，打造STEAM营地氛围，赋能孩子未来</p>
        <div class="five">
          <img src="@/assets/camp/w.jpg" alt />
        </div>

        <img src="@/assets/camp/c1.jpg" alt />
        <p class="item-title">海外营地，让孩子更领先于同龄人</p>
        <p class="small-title">连接全球优秀创客青少年，和国外同龄人一起组队学习，更早适应海外学习方式</p>
        <Row class="tip">
          <i-col span="6">
            <div class="circle">
              <img src="@/assets/camp/c2.png" alt />
            </div>
            <p>多一群海外同学</p>
            <p>格局更国际化</p>
          </i-col>
          <i-col span="6">
            <div class="circle">
              <img src="@/assets/camp/c3.png" alt />
            </div>

            <p>习得领先国内的</p>
            <p>STEAM知识</p>
          </i-col>
          <i-col span="6">
            <div class="circle">
              <img src="@/assets/camp/c4.png" alt />
            </div>
            <p>项目更贴近现实</p>
            <p>激发灵感，探索身边</p>
          </i-col>
          <i-col span="6">
            <div class="circle">
              <img src="@/assets/camp/c5.png" alt />
            </div>
            <p>提升管理能力</p>
            <p>时间/任务/团队合作</p>
          </i-col>
        </Row>
        <div class="bottom-content">
          <img src="@/assets/camp/c1.jpg" alt />
          <p class="item-title">精选国内外良质营地</p>
          <p class="small-title">营员住宿，学习，膳食和创作的地方，范围全球各地</p>
          <div class="area">
            <Row style="margin-bottom: 20px;">
              <i-col span="6">
                <span>广东广州</span>
              </i-col>
              <i-col span="6">
                <span>云南大理</span>
              </i-col>
              <i-col span="6">
                <span>美国华盛顿</span>
              </i-col>
              <i-col span="6">
                <span>印尼巴厘岛</span>
              </i-col>
            </Row>
            <Row>
              <i-col span="6">
                <span>广东清远</span>
              </i-col>
              <i-col span="6">
                <span>香港特别行政区</span>
              </i-col>
              <i-col span="6">
                <span>英国伯明翰</span>
              </i-col>
              <i-col span="6">
                <span>新加坡</span>
              </i-col>
            </Row>
          </div>
        </div>
        <img src="@/assets/camp/c1.jpg" style="margin-top: 50px" alt />
        <p class="item-title">为什么选择少儿编程营地</p>
        <p class="small-title">教育第一，技术第二</p>
        <Row class="tip">
          <i-col span="6">
            <svg-icon icon-class="c1" class="circle-svg"></svg-icon>
            <p>充满激情的导师</p>
            <span>导师团队由毕业于国内外顶尖大学高校热衷营地教育与STEAM创客科技的教育者组成</span>
          </i-col>
          <i-col span="6">
            <svg-icon icon-class="c2" class="circle-svg"></svg-icon>
            <p>劳逸结合的活动</p>
            <span>营地活动除了STEAM创客科技，还融合自然户外、人文文化等元素</span>
          </i-col>
          <i-col span="6">
            <svg-icon icon-class="c3" class="circle-svg"></svg-icon>
            <p>STEAM综合性设计</p>
            <span>活动课程设计沿用前沿的STEAM教学模式，引导营员自我思考和改进等能力</span>
          </i-col>
          <i-col span="6">
            <svg-icon icon-class="c4" class="circle-svg"></svg-icon>
            <p>营地安全保障体系</p>
            <span>选择半/全封闭的营地环境，并在营地内配备相应医疗急救员及医疗设施</span>
          </i-col>
        </Row>
      </div>
    </div>
    <div class="footer-content">
      <div class="logo">
        <img src="@/assets/logo_white.png" alt />
      </div>
      <p class="item-title">少儿编程STEAM创客夏冬令营</p>
      <p class="small-title">适合6~18岁青少年的STEAM创客主题营</p>
      <p class="large-title">
        "我的孩子非常喜欢少儿编程的夏令营。他在哪认识了很多新朋友，而且开始<br>变得外向，也更愿意和别人合作。非常感谢少儿编程老师们。"
      </p>
      <p class="name">少儿编程学员家长</p>
      <!-- <p class="small-title">少儿编程STEAM创客夏冬营营员家长</p> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      swiperOptions: {
        speed:800,
        effect: "fade",
        //自动轮播
        autoplay: {
          delay: 5000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true,
      },
    };
  },
};
</script>
<style lang="scss">
.camp {
  .require {
    .ivu-card-shadow {
      box-shadow: 0px 0px 5px rgba(202, 222, 230, 0.407843);
      .ivu-card-body {
        padding: 0;
      }
    }
  }
  .ivu-carousel-arrow {
    top: 45%;
    background: unset;
    .ivu-icon {
      font-size: 54px;
      opacity: 0.6;
    }
  }
}
</style>
<style lang="scss" scoped>
.camp {
  color: #333;
  position: relative;
  overflow: hidden;
  width: 100%;
  margin-top: -80px;
  padding-top: 80px;
  .top-content {
    margin-top: -80px;
    padding-top: 80px;
    background: linear-gradient(
      180deg,
      rgba(111, 134, 214, 1) 7%,
      rgba(77, 188, 235, 1) 100%
    );
    .wdd {
      width: 1500px;
      margin: 0 auto;
      position: relative;
      .top-tip {
        background-color: rgba(130, 202, 109, 1);
        height: 74px;
        font-size: 28px;
        color: #fff;
        line-height: 74px;
      }
      .carousel {
        overflow: unset!important;
        .demo-carousel {
          position: relative;
          img {
            width: 100%;
            height: 750px;
          }
        }
      }
      .camp-word {
        z-index: 99;
        color: #fff;
        position: absolute;
        top: 0;
        text-align: center;
        width: 100%;
        height: 100%;
        padding-top: 150px;
        background: rgba(0, 0, 0, 0.2);
        h1 {
          font-size: 72px;
          margin-bottom: 40px;
        }
        p {
          font-size: 25px;
        }
        a {
          width: 173px;
          height: 58px;
          margin-top: 40px;
          line-height: 58px;
          background: #82ca6d;
          display: inline-block;
          border-radius: 58px;
          font-size: 25px;
          margin-right: 40px;
          &:hover {
            background: #444;
          }
        }
      }
    }
  }
  .explain {
    font-size: 0;
    position: absolute;
    left: -394px;
    top: 670px;
    z-index: 999;
    .wave {
      width: 2440px;

      height: 104px;
    }
  }
  .item-title {
    margin: 40px 0;
    font-family: "Rockwell Bold", "Rockwell Regular", "Rockwell", sans-serif;
    font-weight: 700;
    font-size: 40px;
  }
  .small-title {
    font-size: 25px;
  }
  .content {
    font-size: 15px;
    background: #fefefe;
    position: relative;
    z-index: 9999;
    margin-top: -137px;
    img {
      width: 93px;
    }

    .require {
      margin-top: 40px;
      margin-bottom: 120px;
      .card-list {
        padding-bottom: 30px;
        width: 334px;
        height: 428px;
        margin-bottom: 50px;
        img {
          width: 334px;
          height: 188px;
          margin: 0 -18px;
        }
        p {
          font-size: 30px;
          font-weight: 700;
          margin: 30px 0;
        }
        span {
          font-size: 25px;
          padding: 0 18px;
          display: block;
        }
      }
    }
    .five {
      margin-top: 80px;
      margin-bottom: 120px;
      img {
        width: 1148px;
      }
    }
    .tip {
      width: 1200px;
      margin: 0 auto;
      padding: 60px 0;
      p {
        font-size: 28px;
        font-weight: 700;
      }
      span {
        font-size: 18px;
        display: block;
        width: 86%;
        margin: 0 auto;
        margin-top: 20px;
      }
      .circle {
        background: #fff;
        border-radius: 50%;
        box-shadow: 0px 0px 5px rgba(202, 222, 230, 0.407843);
        width: 50%;
        margin: 0 auto;
        padding: 15px 0;
        margin-bottom: 20px;
        height: 140px;
      }
      .circle-svg {
        width: 217px;
        height: 217px;
        svg {
          width: 100%;
          height: 100%;
        }
      }
    }
    .bottom-content {
      padding: 50px 0;
      background: rgb(250, 250, 250);
      .area {
        width: 1000px;
        color: #70b603;
        font-size: 25px;
        text-align: left;
        margin: 40px auto;
      }
    }
  }
  .footer-content {
    color: #fff;
    background: linear-gradient(
      180deg,
      rgba(53, 232, 150, 1) -117%,
      rgba(105, 103, 206, 1) 96%
    );
    background-size: 100% 140%;
    padding-top: 60px;
    padding-bottom: 100px;
    .large-title {
      margin-top: 40px;
      margin-bottom: 70px;
      font-size: 40px;
      font-family: "Rockwell Bold", "Rockwell Regular", "Rockwell", sans-serif;
      font-weight: 700;
      line-height: 50px;
    }
    .name {
      margin-bottom: 30px;
      font-family: "Rockwell Bold", "Rockwell Regular", "Rockwell", sans-serif;
      font-weight: 700;
      font-size: 25px;
    }
    .logo {
      margin: 0 auto;
      width: 93px;
      height: 93px;
      border-radius: 50%;
      background: #70b603;
      padding-top: 14px;
      img {
        width: 57px;
        height: 60px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/camp.vue